import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=5c0c1678&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"
import style0 from "./logout.vue?vue&type=style&index=0&id=5c0c1678&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c1678",
  null
  
)

export default component.exports